import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Select,
  Text,
} from "@chakra-ui/react";
import { connect } from "react-redux";
import { getALLTeacher } from "../../../configs/redux/action";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup
  .object({
    name: yup.string().required(),
    teacher_id: yup.number().positive().integer().required(),
  })
  .required();

const ClassModal = ({
  isOpen,
  handleCloseModal,
  selectedRow,
  handleSaveChanges,
  getALLTeacher,
  dataTeacher,
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    getALLTeacher();
  }, [getALLTeacher]);

  useEffect(() => {
    if (selectedRow) {
      setValue("name", selectedRow.name);
      setValue("teacher_id", selectedRow.teacher_id);
    } else {
      setValue("name", "");
      setValue("teacher_id", "");
    }
  }, [selectedRow, setValue]);

  const onSubmit = (data) => {
    let id = selectedRow?.id || 0;
    handleSaveChanges(id, data);
  };

  return (
    <Modal isOpen={isOpen} onClose={handleCloseModal}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Data</ModalHeader>
        <ModalCloseButton />
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <FormControl mb={4}>
              <FormLabel htmlFor="name">Name</FormLabel>
              <Input type="text" id="name" {...register("name")} />
              {errors.name && (
                <Text fontSize="xs" color="tomato">
                  {errors.name.message}
                </Text>
              )}
            </FormControl>
            <FormControl mb={4}>
              <FormLabel htmlFor="teacher_id">Teacher Name</FormLabel>
              <Select
                name="teacher_id"
                id="teacher_id"
                {...register("teacher_id")}
              >
                <option value="">Select Teacher</option>
                {dataTeacher.map((teacher) => (
                  <option key={teacher.id} value={teacher.id}>
                    {teacher.name}
                  </option>
                ))}
              </Select>
              {errors.teacher_id && (
                <Text fontSize="xs" color="tomato">
                  {errors.teacher_id.message}
                </Text>
              )}
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} type="submit">
              Save Changes
            </Button>
            <Button variant="ghost" onClick={handleCloseModal}>
              Cancel
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

const reduxState = (state) => ({
  dataTeacher: state.getData.dataTeacher.data,
  loadingData: state.getData.dataTeacher.loading,
});

const reduxDispatch = (dispatch) => {
  return {
    getALLTeacher: () => dispatch(getALLTeacher()),
  };
};

export default connect(reduxState, reduxDispatch)(ClassModal);
